/**
 * ColorCustomizerFeature - Custom colors, low/high saturation
 * Modes: lowSaturation, highSaturation, customColors
 */
import BaseFeature from './BaseFeature.js';

export default class ColorCustomizerFeature extends BaseFeature {
    constructor(widget, options = {}) {
        super(widget, options);
        this.mode = options.mode || 'customColors';
        this.cssClassMap = {
            lowSaturation: 'dhA11y-low-saturation',
            highSaturation: 'dhA11y-high-saturation',
            customColors: 'dhA11y-custom-colors'
        };
        this.customValues = {
            background: null,
            text: null,
            links: null
        };
    }

    enable() {
        super.enable();

        if (this.mode === 'customColors') {
            // Restore saved custom colors
            const saved = this.widget.storage.get('custom_colors');
            if (saved) {
                this.customValues = saved;
                this._applyCustomColors();
            }
        }

        const cls = this.cssClassMap[this.mode];
        if (cls) {
            // Disable conflicting saturation modes
            if (this.mode === 'lowSaturation' && this.widget.isFeatureActive('highSaturation')) {
                this.widget.toggleFeature('highSaturation', false);
            }
            if (this.mode === 'highSaturation' && this.widget.isFeatureActive('lowSaturation')) {
                this.widget.toggleFeature('lowSaturation', false);
            }
            this.addBodyClass(cls);
        }
    }

    disable() {
        super.disable();
        const cls = this.cssClassMap[this.mode];
        if (cls) {
            this.removeBodyClass(cls);
        }
        if (this.mode === 'customColors') {
            this._removeCustomColors();
        }
    }

    /**
     * Set a custom color for a zone
     */
    setColor(zone, color) {
        if (!['background', 'text', 'links'].includes(zone)) return;
        this.customValues[zone] = color;
        this._applyCustomColors();
        this.widget.storage.set('custom_colors', this.customValues);
    }

    /**
     * Apply custom color CSS variables
     */
    _applyCustomColors() {
        const root = document.documentElement;
        if (this.customValues.background) {
            root.style.setProperty('--dhA11y-custom-bg', this.customValues.background);
        }
        if (this.customValues.text) {
            root.style.setProperty('--dhA11y-custom-text', this.customValues.text);
        }
        if (this.customValues.links) {
            root.style.setProperty('--dhA11y-custom-links', this.customValues.links);
        }
        this.addBodyClass('dhA11y-custom-colors');
    }

    /**
     * Remove custom color CSS variables
     */
    _removeCustomColors() {
        const root = document.documentElement;
        root.style.removeProperty('--dhA11y-custom-bg');
        root.style.removeProperty('--dhA11y-custom-text');
        root.style.removeProperty('--dhA11y-custom-links');
    }
}
